import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../environments/environment';


export const authConfigCastlabs: AuthConfig = {
  issuer: environment.castlabs_idp_issuer,
  strictDiscoveryDocumentValidation: false,
  skipIssuerCheck: true,
  redirectUri: window.location.origin + '/',
  clientId: environment.castlabs_idp_app_client_id,
  responseType: 'code',
  scope: 'openid',
  showDebugInformation: true,
  sessionChecksEnabled: true,
  timeoutFactor: 0.75,
  // disablePKCI: true,
  clearHashAfterLogin: false,
  logoutUrl: environment.castlabs_idp_logout_url,
};

export const authConfigAbove: AuthConfig = {
  issuer: environment.above_idp_issuer,
  strictDiscoveryDocumentValidation: false,
  redirectUri: window.location.origin + '/',
  clientId: environment.above_idp_app_client_id,
  responseType: 'code',
  scope: 'email openid phone',
  showDebugInformation: false,
  sessionChecksEnabled: true,
  timeoutFactor: 0.75,
  // disablePKCI: true,
  clearHashAfterLogin: false,
}
